export default "__VITE_ASSET__DXF5NpOY__"